// Video modal - Fancybox olmadan
(function () {
  document.querySelectorAll('.modal-iframe').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      var videoUrl = this.getAttribute('href');
      
      // Modal oluştur
      var modal = document.createElement('div');
      modal.className = 'video-modal-custom';
      modal.innerHTML = 
        '<div class="video-modal-overlay"></div>' +
        '<div class="video-modal-content">' +
          '<button class="video-modal-close">×</button>' +
          '<iframe src="' + videoUrl + '" frameborder="0" allowfullscreen></iframe>' +
        '</div>';
      
      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';
      
      // Kapat
      modal.querySelector('.video-modal-close').addEventListener('click', function() {
        document.body.removeChild(modal);
        document.body.style.overflow = '';
      });
      
      modal.querySelector('.video-modal-overlay').addEventListener('click', function() {
        document.body.removeChild(modal);
        document.body.style.overflow = '';
      });
    });
  });
})();